module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"light-gate\"-in-torrance-california-b47750d721e128cc274d1aec656b964b.png";